import React from "react";

// Budgets are TZS per night. A null max means "no upper limit".
export const BUDGET_PRESETS = [
  { label: "Any budget", min: 0, max: null },
  { label: "Under 30k", min: 0, max: 30000 },
  { label: "30k – 60k", min: 30000, max: 60000 },
  { label: "60k – 100k", min: 60000, max: 100000 },
  { label: "100k – 200k", min: 100000, max: 200000 },
  { label: "200k+", min: 200000, max: null },
];

const isAny = preset => preset.min === 0 && preset.max === null;

const matches = (preset, value) => {
  if (!value || (!value.min && value.max == null)) return isAny(preset);
  return (value.min || 0) === preset.min && (value.max ?? null) === preset.max;
};

export default function BudgetSelector({ value, onChange, wrap = false }) {
  return (
    <div
      role="group"
      aria-label="Budget per night"
      className={`flex gap-2 ${wrap ? "flex-wrap" : "-mx-1 overflow-x-auto px-1 py-0.5 scrollbar-hide"}`}
    >
      {BUDGET_PRESETS.map(preset => {
        const active = matches(preset, value);
        return (
          <button
            key={preset.label}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(isAny(preset) ? null : { min: preset.min, max: preset.max })}
            className={`pill shrink-0 ${active ? "pill-active" : ""}`}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
}
